// U22b (22 Sep 2026) — kategori paket harga = DATA (`GET /api/master/kategori-harga`),
// bukan daftar tetap BUDGET/SPORTY/ELEGANT/EVENT di tiap layar. Satu pemuat untuk
// FAWizard, FADetail, dan Daftar Harga; label yang tampil = `label` master, nilai yang
// dikirim = `kode`. Kategori nonaktif tidak ditawarkan (tulisan baru saja, K188).
import { useEffect, useState } from "react";
import { api } from "./api";

let _cache = null;
let _janji = null;

export async function muatKategoriHarga({ semua = false, segar = false } = {}) {
  if (semua || segar || !_cache) {
    const p = api.get("/master/kategori-harga", semua ? { params: { semua: 1 } } : undefined)
      .then((r) => (Array.isArray(r.data) ? r.data : []));
    if (semua) return p;                // daftar lengkap tidak di-cache (layar Owner saja)
    _janji = p.then((d) => { _cache = d; return d; }).catch(() => (_cache || []));
    return _janji;
  }
  return _cache;
}

export function bersihkanCacheKategoriHarga() { _cache = null; _janji = null; }

/** Kategori AKTIF, urut `urutan`. Sebelum termuat: []. `segar` memaksa muat ulang. */
export function useKategoriHarga(segar = false) {
  const [daftar, setDaftar] = useState(_cache || []);
  useEffect(() => {
    let hidup = true;
    muatKategoriHarga({ segar }).then((d) => { if (hidup) setDaftar(d); });
    return () => { hidup = false; };
  }, [segar]);
  return daftar;
}

export function labelKategori(daftar, kode) {
  return (daftar || []).find((k) => k.kode === kode)?.label || kode || "";
}

/** Label + KODE untuk layar STAF (dropdown wizard/FA, tabel Daftar Harga).
 *  Sebabnya terukur dari layar 23 Sep 2026: tiga kategori seed (BUDGET · SPORTY ·
 *  ELEGANT) sama-sama berlabel "JERSEY ATASAN FULL PRINT" — label saja membuat
 *  ketiganya tidak bisa dibedakan CS. Dokumen customer TETAP memakai label saja
 *  (fa_orders.kategori_harga_label, K188 c): kode adalah identitas mesin, bukan
 *  nama yang dibaca customer. */
export function labelDenganKode(daftar, kode) {
  const b = (daftar || []).find((k) => k.kode === kode);
  if (!b) return kode || "";
  return b.label === b.kode ? b.label : `${b.label} (${b.kode})`;
}

/** Nilai awal dropdown: kategori aktif pertama (urutan), atau kode yang diberi bila masih aktif. */
export function kodeBawaan(daftar, kodeLama) {
  if (kodeLama && (daftar || []).some((k) => k.kode === kodeLama)) return kodeLama;
  return daftar?.[0]?.kode || kodeLama || "";
}
